import React from 'react';
import i18n from '@i18next/i18n';
import { Feature } from '@tencent/workbench';
import Menu from '@tencent/dui/lib/components/Menu';
import BaseGridFeature from '@framework/workbench/common/feature/base-grid-feature';
import { ColumnItem, config } from './config';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { TOOLBAR_COLUMN_ICON } from '@src/framework/editor/src/img/pageIndex';

@Feature()
export class ColumnsFeature extends BaseGridFeature {
    id = config.id;
    config = config;
    constructor() {
        super();
    }

    public getBottomSlot() {
        return (
            <Menu.Item
                style={{ padding: '9px 16px 9px 28px' }}
                onClick={this.handleOpen}
            >
                <ColumnItem icon={TOOLBAR_COLUMN_ICON} text={i18n.t('更多栏')} />
            </Menu.Item>
        );
    }

    public handleMenuClick = (index: number) => {
        const { dropdown } = this.config;
        if (!dropdown) return;
        const itemData = dropdown.data[index];
        const columnData = { columnNumber: itemData.id };
        this.callback(columnData);
    };

    public getItemValue = () => {
        const values = this.getMenuManager()?.toolbarMenu().values;
        return values?.[ActionType.COLUMN_NUMBER];
    };

    private handleOpen = () => {
        const values = this.getMenuManager()?.toolbarMenu().values;
        const currentColumnData = {
            columnNumber: values?.[ActionType.COLUMN_NUMBER],
            columnSpace: values?.[ActionType.COLUMN_SPACE],
        };
        this.getAppService().editableServiceLayer?.columnDialogDynamicManager
            .promise().then((columnDialogDynamicManager) => {
                columnDialogDynamicManager.showDialog(currentColumnData);
            });
    };
}
